module.exports = __webpack_public_path__ + "static/media/bmwe_logo_en.5a13cbb0.svg";